import { createAsyncThunk } from "@reduxjs/toolkit";
import { userService } from "../../services";

export const getAccountInfo = createAsyncThunk(
  "user/getAccountInfo",
  async (_, { rejectWithValue }) => {
    const response = await userService.getAccountInfo();
    if (!response) return rejectWithValue("offline");
    if (response.status < 300)
      return rejectWithValue("An error has occured, try again later");
    return response;
  }
);

export const updateAccountInfo = createAsyncThunk(
  "user/updateAccountInfos",
  async (userInfos, { rejectWithValue }) => {
    if (userInfos.birthDate === "") delete userInfos.birthDate;

    const response = await userService.updateAccountInfo(userInfos);
    if (!response) return rejectWithValue("offline");
    if (response.status < 300)
      return rejectWithValue("An error has occured, try again later");
    return userInfos;
  }
);

export const socialLogin = createAsyncThunk(
  "user/socialLogin",
  async (providerInfo, { rejectWithValue }) => {
    const response = await userService.socialLogin(providerInfo);
    if (!response) return rejectWithValue("offline");
    return response;
  }
);

export const login = createAsyncThunk(
  "user/login",
  async (userInfos, { rejectWithValue }) => {
    const response = await userService.login(
      userInfos.login,
      userInfos.password
    );
    if (!response) return rejectWithValue("offline");
    return response;
  }
);

export const register = createAsyncThunk(
  "user/register",
  async (userInfos, { rejectWithValue }) => {
    const response = await userService.register(userInfos);
    if (!response) return rejectWithValue("offline");
    if (response.status < 300)
      return rejectWithValue("An error has occured, try again later");
    return response;
  }
);

export const updateAvatar = createAsyncThunk(
  "user/updateAvatar",
  async (infos, { rejectWithValue }) => {
    const response = await userService.updateAvatar(infos);
    if (!response) return rejectWithValue("offline");
    if (response.status < 300)
      return rejectWithValue("An error has occured, try again later");
    return { data: response, old: infos.img };
  }
);

export const recoverPassword = createAsyncThunk(
  "user/recoverPassword",
  async (email, { rejectWithValue }) => {
    const response = await userService.recoverPassword(email);
    if (!response) return rejectWithValue("offline");
    return response;
  }
);

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async (infos, { rejectWithValue }) => {
    const response = await userService.resetPassword(infos.key, infos.password);
    if (!response) return rejectWithValue("offline");
    return response;
  }
);

export const loginWithKey = createAsyncThunk(
  "user/loginWithKey",
  async (infos, { rejectWithValue }) => {
    const response = await userService.loginWithKey(infos.iv, infos.content);
    if (!response) return rejectWithValue("offline");
    return response;
  }
);
